import {
  Ng2ScrollableDirective,
  Ng2MessagePopupComponent,
  Ng2PopupComponent,
  Ng2OverlayManager,
  Ng2MapComponent,
  Ng2UIModule,
  Ng2MapModule
} from './ng2-ui.module';

export {
  Ng2OverlayManager,
  Ng2PopupComponent,
  Ng2MessagePopupComponent,
  Ng2MapComponent,
  Ng2ScrollableDirective,
  Ng2MapModule,
  Ng2UIModule
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/index.ts